import { render } from "./modernMusic.vue?vue&type=template&id=72503ff1"
import script from "./modernMusic.vue?vue&type=script&lang=js"
export * from "./modernMusic.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\david\\Desktop\\Netloud\\whiteLabel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__